import { render, staticRenderFns } from "./vessel-speed.vue?vue&type=template&id=623ecf96"
import script from "./vessel-speed.vue?vue&type=script&lang=js"
export * from "./vessel-speed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports